// 我的证书详情
<template>
  <div>
    <header-img  :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">{{tyepStatus(info.type)}}详情</div>
      <div>  
       <p v-if="info.expressNumber && info.applyVersion == 2" style="text-align: center;">纸质版已发放给您，快递单号是：{{info.expressNumber }}，请注意查收！</p>
       <div v-if="fileTypeInChild == 'pdf'" class="size">
         <iframe width=“100%” height=“100%” :src="info.certificateUrl" class="size" style="height:700px;"></iframe>
       </div>
       <div class="demo-image__preview" v-else>
         <el-image :lazy="true" class="size" :src="info.certificateUrl"  :preview-src-list="[info.certificateUrl]"> </el-image>
          <div class="small-tip">点击图片放大</div>
       </div>
      </div>
      <div class="btn_wrap" style="margin: 40px 0">
        <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue'
import HeaderImg from "@/components/HeaderImg";
import { sessionStore } from '@/utils/data-management'
export default {
  components: {
    ChooseSearch,
    HeaderImg,
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" }
      ],
      info:{
        certificateUrl:"",
        type:'',
        expressNumber:''
      },
      fileTypeInChild: ''
    }
  },
  mounted() {
    if(this.$route.query.listSource == 'zc'){
      this.headerList.push({ name: '我的资产',path: "/MyAsset" }) 
    }else if(this.$route.query.listSource == 'gp'){
      this.headerList.push({ name: '我的挂牌',path: "/MyApplyList" }) 
    }else{
      this.headerList.push({ name: '我的证书',path: "/MyCertificate" }) 
    }
    this.info = sessionStore.get('CertificateDetail')
    this.headerList.push({ name: `${this.tyepStatus(this.info.type)}详情`,})    
    let filePath = this.info.certificateUrl;
    if(filePath){
      let index= filePath.lastIndexOf(".");
      this.fileTypeInChild = filePath.substr(index+1);
    }
  },
  methods: {
    previewLook(){
      if(this.fileTypeInChild == 'pdf'){
        window.open(this.info.certificateUrl, "_blank");
      }
    },
    tyepStatus(v){
       switch (v) {
        case 1:
          return '交易鉴证书'
          break
        case 2:
          return '解押通知书'
          break
        case 3:
          return '贷款还清证明'
          break
        default:
          return '交易鉴证书'
          break
      }
    }
   
  },
}
</script>
<style lang="scss" scoped>
.size{
  width: 600px; 
  display: block;
  margin: 30px auto;
}
.small-tip{
  font-size: 14px;
  color: #a7a8aa;
  margin: 10px auto;
  text-align: center;
}
</style>